export default {"src":"/_next/static/media/gl-carousel-1-8.b458a427.svg","height":42,"width":42,"blurWidth":0,"blurHeight":0};